import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { v4 } from 'uuid';
import { keys } from '../../constants/keys.esm.js';
import { getTypeAndSelected } from './get-type-and-selected.esm.js';
import { LayoutType } from '../../types/layouts.esm.js';

var entityToLayout = function entityToLayout(resources, predefinedLayouts) {
  return function (entity) {
    var typeAndSelected = getTypeAndSelected(entity);
    if (!typeAndSelected) {
      throw new Error('invalid layout');
    }
    var type = typeAndSelected.type,
      selected = typeAndSelected.selected;
    switch (type) {
      case LayoutType.Default:
        {
          throw new Error("Default layout are not stored in the database");
        }
      case LayoutType.Custom:
        {
          var _entity$value;
          if (!selected) {
            throw new Error("The custom layout is stored in the database only if it is current/instance");
          }
          var fields = (_entity$value = entity.value) === null || _entity$value === void 0 ? void 0 : _entity$value.columns;
          var label = resources.layouts.custom();
          var id = keys.custom;
          return {
            type: type,
            selected: selected,
            fields: fields,
            id: id,
            label: label
          };
        }
      case LayoutType.Predefined:
        {
          var _entity$value2;
          if (!selected) {
            throw new Error("Predefined layouts are stored in the database only if it is current/instance");
          }
          if (!((_entity$value2 = entity.value) !== null && _entity$value2 !== void 0 && _entity$value2.layoutId)) {
            throw new Error("Predefined layouts must have their ID stored in the database");
          }
          //Since predefined layouts may be stored in the database using the id="instance", we need to identify the selected layout by name
          var layout = predefinedLayouts.find(function (l) {
            var _entity$value3;
            return l.type === LayoutType.Predefined && l.id === ((_entity$value3 = entity.value) === null || _entity$value3 === void 0 ? void 0 : _entity$value3.layoutId);
          });
          if (!layout) {
            var _entity$value4;
            throw new Error("The predefined layout \"".concat((_entity$value4 = entity.value) === null || _entity$value4 === void 0 ? void 0 : _entity$value4.layoutId, " does not exists"));
          }
          return _objectSpread2(_objectSpread2({}, layout), {}, {
            selected: selected
          });
        }
      case LayoutType.Saved:
        {
          var _entity$value5, _entity$value6;
          var _id = selected ? v4() : entity.instance;
          var _label = (_entity$value5 = entity.value) === null || _entity$value5 === void 0 ? void 0 : _entity$value5.name;
          var _fields = (_entity$value6 = entity.value) === null || _entity$value6 === void 0 ? void 0 : _entity$value6.columns;
          return {
            type: type,
            selected: selected,
            fields: _fields,
            id: _id,
            label: _label
          };
        }
      default:
        throw new Error("Invalid layout type");
    }
  };
};

export { entityToLayout };
//# sourceMappingURL=entity-to-layout.esm.js.map
